/* Kanva V3 — sticky buy bar reveal + variant sync + gallery entrance.
   Loaded only on the product.v3 template. Guarded: no-ops when the bar
   or sentinel is absent. No dependencies. */
(function () {
  'use strict';

  var bar = document.querySelector('[data-buybar]');
  var sentinel = document.querySelector('[data-buybar-sentinel]');

  function setBuybar(on) {
    if (!bar) return;
    bar.classList.toggle('is-visible', on);
    if (on) bar.removeAttribute('inert');
    else bar.setAttribute('inert', '');
  }

  /* Reveal after a set scroll share (mobile PDP), or once the primary CTA
     has been scrolled past. */
  var after = bar ? parseFloat(bar.getAttribute('data-buybar-after') || '') : 0;
  if (bar && after > 0) {
    var ticking = false;
    function measure() {
      ticking = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      setBuybar(max > 0 && window.scrollY / max >= after);
    }
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(measure);
      },
      { passive: true }
    );
    measure();
  } else if (bar && sentinel && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        // Only when the CTA has been scrolled *past* (above the viewport),
        // not when it is still below the fold on load.
        setBuybar(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );
    observer.observe(sentinel);
  }

  /* ----- Variant sync: mirror price and availability into the bar -----
     kanva.js loads first, so its change handler has already formatted the
     price into [data-cta-price] by the time this one runs. */
  if (bar) {
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches('[data-variant-radio]')) return;

      var priceEl = bar.querySelector('[data-buybar-price]');
      var mainPrice = document.querySelector('[data-cta-price]');
      if (priceEl && mainPrice) priceEl.textContent = mainPrice.textContent;

      var cta = bar.querySelector('[data-buybar-cta]');
      if (cta) {
        if (input.dataset.available === 'false') {
          cta.setAttribute('disabled', 'disabled');
          cta.textContent = cta.dataset.soldOutText || 'Sold out';
        } else {
          cta.removeAttribute('disabled');
          cta.textContent = cta.dataset.addText || 'Add to cart';
        }
      }
    });
  }

  /* ----- Mobile gallery: dot indicator + gentle autoplay -----
     The strip is a plain scroll-snap container, so the current slide is derived
     from scrollLeft instead of being tracked in state — a finger swipe and a
     programmatic scroll then update the dots through the same path.
     The carousel is display:none above 767px, so it never intersects and
     autoplay stays off on desktop without duplicating the media query here. */
  document.querySelectorAll('[data-swipe]').forEach(function (track) {
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    var scope = track.closest('[data-gallery]') || track.parentNode;
    var dots = scope.querySelectorAll('[data-swipe-dot]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var seconds = parseFloat(track.dataset.swipeAutoplay);
    var autoplayMs = seconds > 0 && !reduceMotion ? seconds * 1000 : 0;
    var active = 0;
    var timer = null;
    var resumeTimer = null;
    var frame = null;
    var visible = false;

    function offsetOf(index) {
      return (
        slides[index].getBoundingClientRect().left -
        track.getBoundingClientRect().left +
        track.scrollLeft
      );
    }

    function nearestIndex() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestGap = Infinity;
      slides.forEach(function (slide, i) {
        var gap = Math.abs(offsetOf(i) + slide.offsetWidth / 2 - center);
        if (gap < bestGap) {
          bestGap = gap;
          best = i;
        }
      });
      return best;
    }

    function paint(index) {
      active = index;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function goTo(index) {
      track.scrollTo({ left: offsetOf(index), behavior: reduceMotion ? 'auto' : 'smooth' });
      paint(index);
    }

    function start() {
      if (timer || !autoplayMs || !visible || document.hidden) return;
      timer = setInterval(function () {
        goTo((active + 1) % slides.length);
      }, autoplayMs);
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    /* A swipe or a dot tap hands control to the shopper; autoplay only comes
       back once they have been still for a while. */
    function pause() {
      stop();
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(start, 6000);
    }

    track.addEventListener(
      'scroll',
      function () {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          paint(nearestIndex());
        });
      },
      { passive: true }
    );

    ['pointerdown', 'touchstart', 'wheel'].forEach(function (type) {
      track.addEventListener(type, pause, { passive: true });
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        pause();
        goTo(i);
      });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) start();
          else stop();
        },
        { threshold: 0.5 }
      ).observe(track);
    } else {
      visible = window.matchMedia('(max-width: 767px)').matches;
      start();
    }
  });

  /* ----- Gallery: retrigger the anchored entrance when a thumb swaps the stage ----- */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var stage = gallery && gallery.querySelector('[data-stage] img');
    if (!stage) return;
    stage.classList.remove('kv3-swap-in');
    // Force a reflow so removing and re-adding the class restarts the animation.
    void stage.offsetWidth;
    stage.classList.add('kv3-swap-in');
  });
})();
